import { EPushNoticationPublishType } from "./push-notification-settings";

export interface IAppStoreConnectApiSettings {
  id: string;
  name: string;
  p8FileName?: string;
  p8FileDisplayName?: string;
  issuerId: string;
  appleId: string;
  appStoreConnectTeamId: string;
  developerTeamId: string;
  publishType?: EIOSPublishType;
  appetizeApiToken?: string;
  inAppPurchaseP8FileName?: string;
  inAppPurchaseP8FileDisplayName?: string;
  appstorePublishType?: EPushNoticationPublishType;
  configIds?: string[];
}

export enum EIOSPublishType {
  TestFlight = 0,
  Simulator = 1,
  Ipa = 2
}
